import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'
import { DesktopGuide } from '@/components/desktop-guide'
import { MobileGuide } from '@/components/mobile-guide'

export default function DocsPage() {
  return (
    <ContentPage
      eyebrow="// documentation"
      title="NewChirp Documentation"
      description="Desktop and Android guides for installing NewChirp, connecting over Bluetooth or USB, and managing radio channels with confidence."
      wide
    >
      <DesktopGuide />
      <MobileGuide variant="reference" />
      <div className="mx-auto max-w-4xl pt-10">
        <Prose>
        <Section title="Cables & drivers">
          <p>
            The programming cable is the most common source of trouble. Cheaper cables often use a
            counterfeit serial chipset that needs a specific driver. If your radio is not detected,
            confirm the cable appears as a serial port in your operating system before contacting
            support.
          </p>
          <p>
            On macOS and Linux you rarely need extra drivers. On Windows, install the driver that
            matches your cable&apos;s chipset and note the COM port number it is assigned.
          </p>
        </Section>

        <Section title="Backing up your radio">
          <p>
            Before making changes, always download and save the current memory image as a backup. If
            anything goes wrong, you can restore the radio to its original state by uploading the
            saved image. NewChirp image files are small and easy to archive.
          </p>
        </Section>

        <Section title="Keep learning">
          <p>New to all of this? These pages will get you up to speed quickly:</p>
          <div className="flex flex-wrap gap-3">
            <Link
              href="/beginners-guide"
              className="rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary/40 hover:bg-secondary/60"
            >
              Beginners Guide
            </Link>
            <Link
              href="/faq"
              className="rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary/40 hover:bg-secondary/60"
            >
              Frequently Asked Questions
            </Link>
            <Link
              href="/support"
              className="rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary/40 hover:bg-secondary/60"
            >
              Report an Issue
            </Link>
          </div>
        </Section>
        </Prose>
      </div>
    </ContentPage>
  )
}
